"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ServiceLocator_1 = __importDefault(require("chaire-lib-common/lib/utils/ServiceLocator"));
const MapCursorHelper_1 = require("../MapCursorHelper");
/* This file encapsulates map events specific for the 'accessibilityMap' section */
const isAccessMapActiveSection = (activeSection) => activeSection === 'accessibilityMap' || activeSection === 'accessibilityComparison';
const isAccessMapComparisonActiveSection = (activeSection) => activeSection === 'accessibilityComparison';
const onAccessMapSectionMapClick = (e) => {
    ServiceLocator_1.default.eventManager.emit('routing.transitAccessibilityMap.clickedOnMap', e.lngLat.toArray(), 'accessibilityMapLocation');
    e.originalEvent.stopPropagation();
};
const onAccessMapMouseDown = (e) => {
    var _a;
    if (!e.features || e.features.length === 0) {
        return;
    }
    // start drag:
    const feature = e.features[0];
    const map = e.target;
    ServiceLocator_1.default.eventManager.emit('map.disableDragPan');
    map._currentDraggingFeature = (_a = feature.properties) === null || _a === void 0 ? void 0 : _a.location;
    (0, MapCursorHelper_1.addDraggingClass)();
    e.originalEvent.stopPropagation();
};
const onAccessMapMouseUp = (e) => {
    const map = e.target;
    if (map._currentDraggingFeature === 'accessibilityMapLocation' ||
        map._currentDraggingFeature === 'accessibilityMapLocation2') {
        ServiceLocator_1.default.eventManager.emit('routing.transitAccessibilityMap.dragLocation', e.lngLat.toArray(), map._currentDraggingFeature);
        map._currentDraggingFeature = null;
        (0, MapCursorHelper_1.removeDraggingClass)();
        (0, MapCursorHelper_1.removeHoverClass)(); // Clean up hover state since mouseleave doesn't fire during drag
        ServiceLocator_1.default.eventManager.emit('map.enableDragPan');
        e.originalEvent.stopPropagation();
    }
};
const onAccessMapMouseMove = (e) => {
    const map = e.target;
    if (map._currentDraggingFeature === 'accessibilityMapLocation' ||
        map._currentDraggingFeature === 'accessibilityMapLocation2') {
        ServiceLocator_1.default.eventManager.emit('routing.transitAccessibilityMap.dragLocation', e.lngLat.toArray(), map._currentDraggingFeature);
        e.originalEvent.stopPropagation();
    }
};
const onLocationComparisonContextMenu = (e) => {
    ServiceLocator_1.default.eventManager.emit('map.showMapComparisonContextMenu', e, [
        {
            title: 'transit:accessibilityComparison:contextMenu:SetAsLocation1',
            onClick: () => ServiceLocator_1.default.eventManager.emit('routing.transitAccessibilityMap.clickedOnMap', e.lngLat.toArray(), 'accessibilityMapLocation')
        },
        {
            title: 'transit:accessibilityComparison:contextMenu:SetAsLocation2',
            onClick: () => ServiceLocator_1.default.eventManager.emit('routing.transitAccessibilityMap.clickedOnMap', e.lngLat.toArray(), 'accessibilityMapLocation2')
        }
    ]);
};
const accessMapSectionEventDescriptors = [
    { type: 'map', eventName: 'click', condition: isAccessMapActiveSection, handler: onAccessMapSectionMapClick },
    {
        type: 'map',
        eventName: 'contextmenu',
        condition: isAccessMapComparisonActiveSection,
        handler: onLocationComparisonContextMenu
    },
    {
        type: 'layer',
        eventName: 'mousedown',
        layerName: 'accessibilityMapPoints',
        condition: isAccessMapActiveSection,
        handler: onAccessMapMouseDown
    },
    { type: 'map', eventName: 'mouseup', condition: isAccessMapActiveSection, handler: onAccessMapMouseUp },
    { type: 'map', eventName: 'mousemove', condition: isAccessMapActiveSection, handler: onAccessMapMouseMove }
];
exports.default = accessMapSectionEventDescriptors;
//# sourceMappingURL=AccessibilityMapSectionMapEvents.js.map